<template>
  <f7-actions v-model:opened="isOpened" @actions:closed="onHide">
    <f7-actions-group>
      <f7-actions-label>{{ assetData.Name }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group class="row no-gap">
      <div class="actions-button col-50" @click="openAssetInfo">
        <div class="actions-button-media">
          <i class="f7-icons icon-asset-details text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('AssetInfo') }}</div>
      </div>
      <div class="actions-button col-50" @click="openCustomerDetails">
        <div class="actions-button-media">
          <i class="f7-icons icon-customer-details text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('CustomerDetails') }}</div>
      </div>

      <div class="actions-button col-50" @click="openDialogActivation">
        <div class="actions-button-media">
          <i class="f7-icons icon-activation text-color-green"></i>
        </div>
        <div class="actions-button-text">{{ $t('Activation') }}</div>
      </div>
      <div class="actions-button col-50" @click="openDialogDeactivation">
        <div class="actions-button-media">
          <i class="f7-icons icon-deactivation text-color-red"></i>
        </div>
        <div class="actions-button-text">{{ $t('Deactivation') }}</div>
      </div>

      <div class="actions-button col-50" @click="openLocation">
        <div class="actions-button-media">
          <i class="f7-icons icon-position text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('Location') }}</div>
      </div>
      <div class="actions-button col-50" @click="openLastAlarms">
        <div class="actions-button-media">
          <i class="f7-icons icon-notification text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('AlarmHistory') }}</div>
      </div>

      <div class="actions-button col-50" @click="openSimStatus" :class="{'disabled': !assetData.SimNO}">
        <div class="actions-button-media">
          <i class="f7-icons icon-sim text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('SimStatus') }}</div>
      </div>
      <div class="actions-button col-50" @click="openConnectivity" :class="{'disabled': !assetData.SimNO}">
        <div class="actions-button-media">
          <i class="f7-icons icon-data text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('Connectivity') }}</div>
      </div>

      <div class="actions-button col-50" @click="openCommands" :class="{'disabled': !SimCommands.length || !assetData.SimNO}">
        <div class="actions-button-media">
          <i class="f7-icons icon-other-commands text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('Commands') }}</div>
      </div>
      <div class="actions-button col-50" @click="openCommandsHistory" :class="{'disabled': !assetData.SimNO}">
        <div class="actions-button-media">
          <i class="f7-icons icon-sms text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('CommandHistory') }}</div>
      </div>

      <div class="actions-button col-50" @click="openDeviceCheck" :class="{'disabled': !assetData.SimNO}">
        <div class="actions-button-media">
          <i class="f7-icons icon-details text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('DeviceCheck') }}</div>
      </div>
      <div class="actions-button col-50" @click="openDeviceConfig" :class="{'disabled': !assetData.SimNO}">
        <div class="actions-button-media">
          <i class="f7-icons icon-live-input text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('DeviceConfig') }}</div>
      </div>


      <div class="actions-button col-50" @click="openTransfer">
        <div class="actions-button-media">
          <i class="f7-icons icon-transfer text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('Transfer') }}</div>
      </div>
      <div class="actions-button col-50" @click="openSendActLetter">
        <div class="actions-button-media">
          <i class="f7-icons icon-email text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('SendActivationLetter') }}</div>
      </div>

    </f7-actions-group>
  </f7-actions>
</template>

<script>

import {openExternalUrl, AdminPermissionsEnum, SortArrayByObjProps, CustomerTypes} from "../../../js/helpers";
import { f7 } from 'framework7-vue';
import { mapGetters } from 'vuex'
import { ApiMethods, QTAPI } from "../../../services/qt-api";

export default {
  name: "asset-menu",

  props: {
    assetData: { type: Object, default: ()=> { return {} } },
    isOpened: { type: Boolean, default: false },
  },

  emits: ['update:isOpened'],

  data() {
    return {

    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'UserInfo', 'SimCommands'])
  },

  methods: {

    openAssetInfo(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'asset-edit',
        //query: { imei: item.IMEI },
      }, {
        props: { assetData: this.assetData }
      })
    },
    openCustomerDetails(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'customer-edit',
        //query: { customerCode: item.IMEI },
        query: { customerName: this.assetData.Owner, customerCode: this.assetData.CustomerCode },
      })
    },
    openLocation(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'asset-position',
        query: { imei: this.assetData.IMEI, imsi: this.assetData.SimNO, name: this.assetData.Name, id: this.assetData.ID }
      })
    },
    openSimStatus(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'sim-status',
        query: { imsi: this.assetData.SimNO }
      })
    },
    openTransfer(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'asset-transfer',
        //query: { imei: item.IMEI },
      }, {
        props: { assetData: this.assetData }
      })
    },
    openLastAlarms(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'asset-last-alarms',
        query: { id: this.assetData.ID, name: this.assetData.Name }
      })
    },
    openCommands(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'sim-send-command',
        query: { imsi: this.assetData.SimNO, imei: this.assetData.IMEI, name: this.assetData.Name, deviceType: this.assetData.Product }
      })

    },
    openCommandsHistory(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'command-history',
        query: { imsi: this.assetData.SimNO, imei: this.assetData.IMEI, name: this.assetData.Name, deviceType: this.assetData.Product }
      })
    },
    openDeviceCheck(){
      this.onHide()
      this.$store.commit('SET_TARGET_ASSET', this.assetData)
      f7.views.main.router.navigate({
        name: 'device-check',
        query: { id: this.assetData.ID, name: this.assetData.Name }
      })
    },
    openDeviceConfig(){
      this.onHide()
      this.$store.commit('SET_TARGET_ASSET', this.assetData)
      f7.views.main.router.navigate({
        name: 'device-config',
        query: { id: this.assetData.ID, name: this.assetData.Name }
      })
    },
    openConnectivity(){
      this.onHide()
      this.$store.commit('SET_TARGET_ASSET', this.assetData)
      f7.views.main.router.navigate({
        name: 'sim-connectivity',
        query: { id: this.assetData.ID, name: this.assetData.Name }
      })
    },
    async openDialogActivation() {
      this.onHide()

      //get agent data and all solutions
      f7.progressbar.show('green');
      let agentInfo = await QTAPI.GetPreEditCustomerInfo({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        Code: this.MajorToken
      })
      await f7.utils.nextTick()
      if (!agentInfo) {
        f7.progressbar.hide();
        return
      }

      //get user data for correct activation link
      let userInfo = await QTAPI.GetPreEditCustomerInfo({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        Code: this.assetData.CustomerCode
      })
      await f7.utils.nextTick()
      f7.progressbar.hide();
      if (!userInfo) {
        return
      }

      //@activationOptionsArr for storing allowed solutions to activate
      //@activationDomain customer domain with activation pages
      let activationOptionsArr = []
      let activationDomain
      if(userInfo.WebSites && userInfo.WebSites.length && userInfo.CustomerInfo && userInfo.CustomerInfo.WebSiteCode){
        //we get user website code from user data and search for this website details in websites array
        activationDomain = userInfo.WebSites.find(itm => itm.Code === userInfo.CustomerInfo.WebSiteCode)?.AURL

      }else if(agentInfo.WebSites && agentInfo.WebSites.length && agentInfo.CustomerInfo && agentInfo.CustomerInfo.WebSiteCode){
        //we get agent website code from user data and search for this website details in websites array
        activationDomain = agentInfo.WebSites.find(itm => itm.Code === agentInfo.CustomerInfo.WebSiteCode)?.AURL
      }

      //if customer has no website we use default activation domain
      if(!activationDomain){
        activationDomain = ApiMethods.GO_FOR_ACTIVATION;
      }

      if(agentInfo.CustomerInfo){
        if(agentInfo.CustomerInfo._FIELD_NVAR1){
          let permissionsArr = agentInfo.CustomerInfo._FIELD_NVAR1.split(',')
          //if customer has permission to Replace device we add this option into @activationOptionsArr
          if(permissionsArr.indexOf('ReplaceUnit') > -1){
            activationOptionsArr.push({
              value: 'ReplaceUnit',
              name: this.$t('Replace')
            })
          }
          //if customer has permission to Upgrade device we add this option into @activationOptionsArr
          if(permissionsArr.indexOf('UpgradeToLive') > -1){
            activationOptionsArr.push({
              value: 'UpgradeToLive',
              name: this.$t('Upgrade')
            })
          }
          //we check each solution if it allowed to activate and if yes then add into @activationOptionsArr
          if(agentInfo.Solutions && agentInfo.Solutions.length){
            agentInfo.Solutions.forEach(solution => {
              if(permissionsArr.indexOf(solution.Value) > -1){
                activationOptionsArr.push({
                  value: solution.Value,
                  name: solution.Name
                })
              }
            })
          }
        }
        //we check if customer allowed to do Install Notice and add it into @activationOptionsArr
        if(agentInfo.CustomerInfo._FIELD_INT1 && (agentInfo.CustomerInfo._FIELD_INT1 & AdminPermissionsEnum.InstallNotice) > 0){
          activationOptionsArr.push({
            value: 'InstallNotice',
            name: this.$t('InstallNotice')
          })
        }
      }
      //if there are activation options we sort it into alphabet order
      if(activationOptionsArr.length){
        activationOptionsArr = SortArrayByObjProps(activationOptionsArr, [{prop: 'name', direction: 1}])
      }
      //if no activation options we show alert
      if(!activationOptionsArr.length){
        f7.dialog.alert(this.$t('NoActivationOptions'))
        return
      }
      //creating html template of activation options
      let content = `
				<div class="list no-hairlines no-margin">
          <ul>${ activationOptionsArr.map(itm =>
            `<li>
              <label class="item-radio item-content color-green">
                <input type="radio" name="radio-activation" value="${itm.value}" checked />
                <i class="icon icon-radio"></i>
                <div class="item-inner">
                  <div class="item-title">${itm.name}</div>
                </div>
              </label>
						</li>`).join('') }
          </ul>
        </div>`;

      //show activation dialog
      f7.dialog.confirm(content, this.$t('SelectActivationOption'), (dialog) => {
        let selected = dialog.$el.find('[name="radio-activation"]:checked').val()
        //add backslash to the end of activation domain if there is no such
        if(activationDomain[activationDomain.length -1] !== "/"){
          activationDomain += '/'
        }
        //check selected option
        switch (selected) {
          //Install Notice always use one url
          case 'InstallNotice':
            activationDomain = ApiMethods.GO_FOR_INSTALL_NOTICE + `install-notice/?DealerToken=${this.MajorToken}&imei=${this.assetData.IMEI}&DealerType=${this.UserInfo.CustomerType}`
            break;
          //UpgradeToLive && ReplaceUnit has separate activation pages but on agent domain
          case 'UpgradeToLive':
            activationDomain += `upgrade-to-live.php?DealerToken=${this.MajorToken}&imeis=${this.assetData.IMEI}&SolutionType=Track&DealerType=${this.UserInfo.CustomerType}`
            break;
          case 'ReplaceUnit':
            activationDomain += `upgrade.php?DealerToken=${this.MajorToken}&imeis=${this.assetData.IMEI}&DealerType=${this.UserInfo.CustomerType}`
            break;
          case 'Deactivate':
            this.openDialogDeactivation()
            return
            //break;
          //and for all solutions selected we use one url
          default:
              activationDomain += `?DealerToken=${this.MajorToken}&imei=${this.assetData.IMEI}&SolutionType=${selected}&DealerType=${this.UserInfo.CustomerType}`
        }

        //open activation page on new tab
        openExternalUrl(activationDomain)
      });
    },

    openDialogDeactivation(){
      this.onHide()
      let content = `
        <div class="custom-modal-text">${ this.$t('DeactivationPrompt', { imei: this.assetData.IMEI }) }</div>
				<div class="list media-list no-hairlines no-hairlines-between no-margin">
          <ul>
            <li>
              <label class="item-radio item-content no-padding color-red">
                <input type="radio" name="radio-deactivate" value="deactivate" checked />
                <i class="icon icon-radio"></i>
                <div class="item-inner no-margin padding-vertical-half no-padding-right no-padding-left">
                  <div class="item-title text-color-black">${ this.$t('Deactivate') }</div>
                  <div class="item-text size-12 line-height-14">${ this.$t('DeactivateDescription') }</div>
                </div>
              </label>
						</li>
						<li>
              <label class="item-radio item-content no-padding color-red">
                <input type="radio" name="radio-deactivate" value="stock" />
                <i class="icon icon-radio"></i>
                <div class="item-inner no-margin padding-vertical-half no-padding-right no-padding-left">
                  <div class="item-title text-color-black">${ this.$t('Stock') }</div>
                  <div class="item-text size-12 line-height-14">${ this.$t('DeactivateStockDescription') }</div>
                </div>
              </label>
						</li>
						<li>
              <label class="item-radio item-content no-padding color-red">
                  <input type="radio" name="radio-deactivate" value="terminate"/>
                  <i class="icon icon-radio"></i>
                  <div class="item-inner no-margin padding-vertical-half no-padding-right no-padding-left">
                      <div class="item-title text-color-black">${ this.$t('Terminate') }</div>
                      <div class="item-text size-12 line-height-14">${ this.$t('DeactivateTerminateDescription') }</div>
                  </div>
              </label>
            </li>
          </ul>
        </div>`;

      f7.dialog.confirm(content, this.$t('SelectDeactivationOption'), async (dialog) => {
        let selected = dialog.$el.find('[name="radio-deactivate"]:checked').val()
        let data = {
          MinorToken: this.MinorToken,
          MajorToken: this.MajorToken,
          IMEI: this.assetData.IMEI,
          type: !selected ? 'deactivate' : selected
        };

        f7.progressbar.show('green');
        const result = await QTAPI.AssetDeactivation(data)
        f7.progressbar.hide();
        if(!result){
          return
        }
        f7.notification.create({
          subtitle: this.$t('Success'),
          text: this.$t('DeactivationSuccess'),
          closeTimeout: 3000,
        }).open();

      });
    },
    async openSendActLetter(){
      this.onHide()

      f7.progressbar.show('green');
      let fullCustomerData = await QTAPI.GetPreEditCustomerInfo({
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        Code: this.assetData.CustomerCode
      });
      f7.progressbar.hide();
      if(!fullCustomerData) return

      if(fullCustomerData?.CustomerInfo?.Type === CustomerTypes.Agent || fullCustomerData?.CustomerInfo?.Type === CustomerTypes.Dealer){
        f7.dialog.alert(this.$t('ActivationLetterErrorAccType'), this.$t('CustomerTypeError'))
        return
      }

      f7.dialog.confirm(this.$t('SendActivationLetterDescription', { name: this.assetData.Owner }), this.$t('SendActivationLetter'), async (dialog) => {
        f7.progressbar.show('green');
        let result = await QTAPI.SendAssetActivationLetter({
          MajorToken: this.MajorToken,
          MinorToken: this.MinorToken,

          IMEI: this.assetData.IMEI
        });
        f7.progressbar.hide();

        if(!result) return

        f7.notification.create({
          subtitle: this.$t('Success'),
          text: this.$t('LetterSent'),
        }).open()
      });
    },

    onHide(){
      this.$emit('update:isOpened', false)
    },
  },

  mounted() {

  },



  beforeDestroy() {

  }
}
</script>